import { render, staticRenderFns } from "./RolesListComponent.vue?vue&type=template&id=3a71eacc&"
import script from "./RolesListComponent.vue?vue&type=script&lang=js&"
export * from "./RolesListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports